import { SENDING_REQUEST, LOGOUT, REQUEST_ERROR, CLEAR_ERROR, REFRESH_REQUEST, PING_REQUEST, SET_CSRFTOKEN, GET_CSRFTOKEN, TIMEOUT_MODAL_STATUS, SESSION_EXPIRATION } from './constants';
export * from './constants';
export var sendingRequest = function sendingRequest(sending) {
  return {
    type: SENDING_REQUEST,
    sending: sending
  };
};
export var requestError = function requestError(error) {
  return {
    type: REQUEST_ERROR,
    error: error
  };
};
export var logout = function logout() {
  return {
    type: LOGOUT
  };
};
export var clearError = function clearError() {
  return {
    type: CLEAR_ERROR
  };
};
export var refreshRequest = function refreshRequest() {
  return {
    type: REFRESH_REQUEST
  };
};
export var pingRequest = function pingRequest() {
  return {
    type: PING_REQUEST
  };
};
export var setCsrfToken = function setCsrfToken(payload) {
  return {
    type: SET_CSRFTOKEN,
    payload: payload
  };
};
export var getCsrfToken = function getCsrfToken(payload) {
  return {
    type: GET_CSRFTOKEN,
    payload: payload
  };
};
export var toggleTimeoutModal = function toggleTimeoutModal(bool) {
  return {
    type: TIMEOUT_MODAL_STATUS,
    payload: bool
  };
};
export var updateExpiration = function updateExpiration(payload) {
  return {
    type: SESSION_EXPIRATION,
    payload: payload
  };
};